import React, { useState, useEffect } from "react";
// Убедитесь, что путь к картинке правильный.
// Если файл в src/assets, используем импорт:
import infoBg from "../assets/info.jpg";
import { useTranslation } from "react-i18next";

const Info_Section = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const [counters, setCounters] = useState({
    squareAreas: 0,
    carParking: 0,
    apartments: 0,
    rooms: 0,
    year: 0,
  });
  const { t, i18n } = useTranslation();

  // Данные для счетчиков: финальное значение, шаг и текст
  const stats = [
    { id: "squareAreas", max: 0, step: 1, label: t("Dissatisfiedcustomers") },
    { id: "carParking", max: 134, step: 2, label: t("Employees") },
    { id: "apartments", max: 3500, step: 35, label: t("Satisfiedcustomers") },
    { id: "rooms", max: 5, step: 1, label: t("Services") },
    { id: "year", max: 6, step: 1, label: t("Trialoftheyear") },
  ];

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Запуск анимации при достижении 800px скролла
  useEffect(() => {
    if (scrollPosition > 800 && !hasStarted) {
      setHasStarted(true);
    }
  }, [scrollPosition, hasStarted]);

  useEffect(() => {
    if (!hasStarted) return;

    const interval = setInterval(() => {
      setCounters((prev) => ({
        squareAreas: Math.min(6, prev.squareAreas + 1),
        carParking: Math.min(95, prev.carParking + 2),
        apartments: Math.min(3500, prev.apartments + 35),
        rooms: Math.min(5, prev.rooms + 1),
        year: Math.min(6, prev.year + 1),
      }));
    }, 25);

    return () => clearInterval(interval);
  }, [hasStarted]);

  const isVisible = scrollPosition > 800;

  return (
    <section
      className={`relative w-full h-auto py-20 px-5 transition-all duration-700 ease-out bg-cover bg-center bg-no-repeat
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      style={{
        // Добавляем легкое затемнение поверх картинки для читаемости текста
        backgroundImage: `linear-gradient(rgba(55, 55, 55, 0.8), rgba(255,255,255,0.1)), url(${infoBg})`,
      }}
    >
      {/* Grid сетка: 1 колонка (мобильные), 2 (планшеты), 3 (десктоп) */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 p-3 backdrop-blur-xl shadow-2xl rounded-3xl lg:grid-cols-3 gap-6 max-sm:gap-4 justify-items-center items-center">
        {stats.map((item) => (
          <div
            key={item.id}
            className="relative flex justify-center items-center w-full max-w-[320px]  py-6"
          >
            {/* Сделали цифры еще прозрачнее (10%), чтобы они не мешали тексту */}
            <span
              className="font-bold text-[60px] sm:text-[120px] lg:text-[130px] text-white leading-none select-none transition-all"
              style={{
                // Делаем середину прозрачной
                opacity: 0.7, // Общая прозрачность цифры
              }}
            >
              {counters[item.id]}
            </span>

            {/* Текст с сильной тенью для читаемости на любом фоне */}
            <h3 className="absolute inset-0 flex items-center justify-center text-yellow-400 text-center font-['Raleway'] max-sm:translate-y-10 sm:translate-y-20 font-black text-xl  sm:text-2xl  uppercase tracking-tighter px-4 leading-tight">
              {item.label}
            </h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Info_Section;
